// extracted by mini-css-extract-plugin
module.exports = {"iconWrapper":"Reporting_iconWrapper__2WjAb"};